import styled from 'styled-components'
import { SPACING, BORDER_RADIUS, COLORS, TYPOGRAPHY, FONT_WEIGHT } from '../../../styles/theme'

export const ReviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`

export const ReviewHeader = styled.div`
  padding-bottom: ${SPACING.lg};
  border-bottom: 1px solid var(--color-border);
  margin-bottom: ${SPACING.lg};
`

export const ReviewTitle = styled.h3`
  font-size: ${TYPOGRAPHY.body.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-primary);
  margin: 0 0 ${SPACING.xs} 0;
`

export const ReviewSubtitle = styled.p`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  line-height: ${TYPOGRAPHY.caption.lineHeight};
  color: var(--color-text-tertiary);
  margin: 0;
`

export const NameFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.sm};
  margin-top: ${SPACING.md};
`

export const ScrollBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: ${SPACING.lg} 0;
`

export const LevelSection = styled.section`
  margin-bottom: ${SPACING.xl};

  &:last-child {
    margin-bottom: 0;
  }
`

export const LevelHeader = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${SPACING.sm};
  margin-bottom: ${SPACING.md};
`

export const LevelTitle = styled.h4`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
`

export const LevelDescription = styled.span`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: var(--color-text-tertiary);
`

export const NodeBlock = styled.div`
  margin-bottom: ${SPACING.lg};
  padding: ${SPACING.md};
  background: var(--color-bg-subtle, rgba(0, 0, 0, 0.02));
  border-radius: ${BORDER_RADIUS.lg};
`

export const NodeHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.xs};
  margin-bottom: ${SPACING.sm};
`

export const NodeBadge = styled.span`
  padding: 2px 8px;
  background: var(--color-primary-bg);
  color: ${COLORS.primary};
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  text-transform: uppercase;
  border-radius: ${BORDER_RADIUS.sm};
  letter-spacing: 0.4px;
`

export const NodeLabel = styled.span`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-primary);
`

export const AddButton = styled.button`
  width: 100%;
  padding: ${SPACING.sm};
  border: 1px dashed var(--color-border-dark);
  background: transparent;
  color: var(--color-text-tertiary);
  cursor: pointer;
  border-radius: ${BORDER_RADIUS.md};
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${SPACING.xs};
  margin-top: ${SPACING.sm};
  transition: all 0.15s ease;

  &:hover {
    border-color: var(--color-primary);
    color: var(--color-primary);
    background: var(--color-primary-bg);
  }
`

export const BottomBar = styled.div`
  margin-top: auto;
  flex-shrink: 0;
  border-top: 1px solid var(--color-border);
  padding-top: ${SPACING.lg};
`

export const ReviewFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${SPACING.sm};
  flex-shrink: 0;
`

export const QuotaFooterBar = styled.div`
  padding-bottom: ${SPACING.md};
  flex-shrink: 0;
`

export const QuotaRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
`

export const Summary = styled.div`
  margin-right: auto;
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: var(--color-text-tertiary);
  display: flex;
  align-items: center;
`

export const MaxDiffSection = styled.section`
  background: var(--color-surface-secondary);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: ${SPACING.md} ${SPACING.lg};
  display: flex;
  flex-direction: column;
  gap: ${SPACING.sm};
`

export const MaxDiffHeader = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${SPACING.xs};
`

export const MaxDiffTitle = styled.h4`
  font-size: ${TYPOGRAPHY.body.fontSize};
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0;
`

export const MaxDiffBadge = styled.span`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: var(--color-text-tertiary);
  font-weight: 400;
`

export const MaxDiffQuestionList = styled.ol`
  margin: 0;
  padding-left: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs};
`

export const MaxDiffQuestionItem = styled.li`
  font-size: ${TYPOGRAPHY.body.fontSize};
  color: var(--color-text-secondary);
`
